import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DEPARTMENT_TYPE_CLASSES } from 'src/app/core/constants';

@Component({
    selector: 'app-classes-attached',
    templateUrl: './classes-attached.component.html',
    styleUrls: ['./classes-attached.component.scss'],
})
export class ClassesAttachedComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Classes
     */
    public departmentType: string = DEPARTMENT_TYPE_CLASSES;

    /**
     * Definição do parâmetro recebido via url através do menu sidebar
     */
    public sessionType;

    constructor(private route: ActivatedRoute) {
        this.route.params.subscribe((params) => (this.sessionType = params['sessionType']));
    }

    ngOnInit(): void {
        //console.log('sessionType=' + this.sessionType);
    }
}
